/**
 * indicates if given value is of type object
 *
 * @param {} value
 * @returns {boolean}
 */
export function isObject(value) {
  return typeof value === "object" && value !== null;
}

export function isString(value) {
  return typeof value === "string" && value !== null;
}

export function isArray(value) {
  return Array.isArray(value);
}

export function isEqual(arr1, arr2, isSort = true) {
  if (!isArray(arr1) || !isArray(arr2)) {
    return arr1 === arr2;
  }
  if (isSort) {
    arr1.sort((a, b) => {
      return a.localeCompare(b);
    });
    arr2.sort((a, b) => {
      return a.localeCompare(b);
    });
  }
  let length = arr1.length;

  if (length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}

export function isDeepEqual(arr1, arr2) {
  if (!isArray(arr1) || !isArray(arr2)) {
    return arr1 === arr2;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i++) {
    let result = isEqual(arr1[i], arr2[i]);

    if (!result) {
      return false;
    }
  }
  return true;
}

export function isArraysInArrayEmpty(arr) {
  if (!arr.length) {
    return true;
  }

  function is(element) {
    return element.length < 1;
  }

  return arr.some(is);
}
